import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, "Lieferungen", -1)
const _hoisted_2 = {
  key: 1,
  class: "divide-y w-full"
}
const _hoisted_3 = { class: "text-xs" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("td", { class: "w-1/12 p-xs" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("td", { class: "w-8/12 p-xs" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "block lg:flex justify-start items-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "w-full" }, "Kiste"),
    /*#__PURE__*/_createElementVNode("div", { class: "w-full" }, "Status")
  ])
], -1)
const _hoisted_6 = {
  key: 0,
  class: "w-2/12 p-xs"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", { class: "w-1/12 p-xs" }, "Verlauf", -1)
const _hoisted_8 = { class: "p-xs" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = {
  key: 0,
  class: "flex items-center justify-start py-xs"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "line-clamp-1" }, "Leer", -1)
const _hoisted_12 = { class: "block lg:flex justify-start items-center p-xs" }
const _hoisted_13 = { class: "w-full" }
const _hoisted_14 = { class: "text-xs block" }
const _hoisted_15 = { class: "text-xs block" }
const _hoisted_16 = { class: "flex flex-col justify-end w-full mr-m" }
const _hoisted_17 = {
  key: 1,
  class: "block lg:flex justify-between items-center"
}
const _hoisted_18 = {
  key: 0,
  class: "text-center p-xs"
}
const _hoisted_19 = { class: "flex items-center justify-start" }
const _hoisted_20 = { class: "p-xs text-center" }
const _hoisted_21 = { class: "flex items-end justify-end mt-m" }
const _hoisted_22 = {
  key: 0,
  class: "w-multiselectbig"
}
const _hoisted_23 = {
  key: 0,
  class: "flex"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_25 = { class: "flex" }

import { computed, ref } from "vue";
import UButton from "@/components/UButton.vue";
import { Message, OrderMedication } from "@/interfaces/message";
import { MessageType } from "@/interfaces/enum/messageType";
import {
  MedicationOrderBoxStatus,
  MedicationOrderStatus,
} from "@/interfaces/enum/medicationOrderStatus";
import RoundedCard from "@/components/RoundedCard.vue";
import DialogCard from "@/components/DialogCard.vue";
import {
  encryptAndSaveMessage,
  updateMessage,
} from "@/helpers/requestHelpers/ordersRequests";
import OrderMessageHistory from "../components/OrderMessageHistory.vue";
import { Conversation } from "@/interfaces/conversation";
import OrderBoxManagement from "./OrderBoxManagement.vue";
import ReactiveSelect from "@/components/ReactiveSelect.vue";
import CoreIcon from "@/components/CoreIcon.vue";
import CircularProgress from "@/components/CircularProgress.vue";
import UmanaHeadline from "@/components/UmanaHeadline.vue";
import IconButton from "@/components/IconButton.vue";
import ToolTip from "@/components/ToolTip.vue";
import ProgressDot from "@/components/ProgressDot.vue";
import EmptyContainer from "@/components/EmptyContainer.vue";
import OrderPrintModal from "./OrderPrintModal.vue";
import { patientString } from "@/helpers/patienthelper";
import {
  formatDate,
  localeDateString,
  upcomingDates,
} from "@/helpers/datehelper";
import LabelButton from "@/components/LabelButton.vue";
import { Weekdays, Weekday } from "@/interfaces/enum/weekdays";
import { getDeliveryStatusOfConversation } from "@/helpers/orderhelper";
import SmallTag from "@/components/SmallTag.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderMessageBoxes',
  props: {
    messages: {},
    conversation: {},
    isSender: { type: Boolean }
  },
  setup(__props: any) {

const showBoxModal = ref<boolean>(false);
const showPrintModal = ref<boolean>(false);
const boxForm = ref<any>({});
const loadingMessages = ref<Set<number>>(new Set());

const selectedBoxId = ref<number>(0);
const editBox = ref<number | undefined>();

const props = __props;

const showHistoryOf = ref<Message | null>(null);

function updateBoxForm() {
  boxForm.value = JSON.parse(
    boxes.value[selectedBoxId.value]?.decrypted_message ?? "{}"
  );
}

function sortedWeekdays() {
  const currentDate = new Date().getDay();
  const weekdays = (props.conversation.senderCareProviderGroup.preferred_weekday
    ?.map((wd) => Weekdays.find((w) => w.id == wd))
    .filter((w) => w !== undefined) ?? []) as Weekday[];
  return weekdays.sort((wd1, wd2) => {
    if (wd1.id > currentDate && wd2.id <= currentDate) {
      return -1;
    }
    if (wd1.id <= currentDate && wd2.id >= currentDate) {
      return 1;
    }
    return wd1.id - wd2.id;
  });
}

function getBoxOrders(boxId: number): Array<Message> {
  let messagesArray = Array.from(props.messages);

  let boxOrders = messagesArray.filter((message) => {
    if (message.medication_order != undefined) {
      if (
        message.medication_order &&
        !message.medication_order.deleted &&
        message.medication_order.box == boxId
      ) {
        return true;
      }
    }
    return false;
  });
  return boxOrders;
}

async function changeDate(
  val:
    | {
        label: string;
        date: string;
        desc: string;
      }
    | undefined
) {
  await encryptAndSaveMessage(props.conversation, {
    type: MessageType.deliveryStatus,
    decrypted_message: JSON.stringify({
      date: val?.date,
    }),
  });
}

async function changeDateAuto(weekday: number) {
  let d = new Date();
  d.setDate(d.getDate() + ((weekday + 7 - d.getDay()) % 7 || 7));

  await encryptAndSaveMessage(props.conversation, {
    type: MessageType.deliveryStatus,
    decrypted_message: JSON.stringify({
      date: formatDate(d),
    }),
  });
}

function getProgressOfBoxId(boxId: number): Array<number> {
  let boxOrders = getBoxOrders(boxId).filter(
    (order) => !order.medication_order?.deleted
  );
  let progress = [0, 0, 0, 0, 0, 0];
  if (boxOrders.length == 0) return [0, 0, 0, 0, 1, 0];

  boxOrders.forEach((boxOrder) => {
    progress[statusOfMedicationOrder(boxOrder.medication_order)] +=
      1.0 / boxOrders.length;
  });
  return progress;
}

function statusOfMedicationOrder(medicationOrder?: OrderMedication) {
  if (medicationOrder && medicationOrder.status) {
    let status = MedicationOrderStatus.find(
      (m) => m.id == medicationOrder.status
    );
    return status?.progress ?? 0;
  }
  return 0;
}

const printBoxes = ref<Message[]>([]);

const boxes = computed<Message[]>(() => {
  return (
    props.messages.filter((message) => message.type == MessageType.box) ?? []
  );
});

const deliveryStatus = computed(() => {
  return getDeliveryStatusOfConversation(props.messages);
});

async function updateBoxes(box: Message, _changes: Map<string, any>) {
  loadingMessages.value.add(box.id);
  window._paq.push([
    "trackEvent",
    "Conversation-Box",
    "Box updated via select",
    undefined,
  ]);
  await updateMessage(props.conversation, box, _changes);
  loadingMessages.value.delete(box.id);
}

function editBoxes() {
  editBox.value = undefined;
  showBoxModal.value = true;
  updateBoxForm();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(UmanaHeadline, {
      h: "h2",
      class: "mb-s mt-s justify-between"
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        (!_ctx.isSender)
          ? (_openBlock(), _createBlock(IconButton, {
              key: 0,
              icon: "pen",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (editBoxes()))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (boxes.value.length == 0)
      ? (_openBlock(), _createBlock(EmptyContainer, { key: 0 }, {
          default: _withCtx(() => [
            _createTextVNode(" Keine Kisten erfasst ")
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock("table", _hoisted_2, [
          _createElementVNode("tr", _hoisted_3, [
            _hoisted_4,
            _hoisted_5,
            (!_ctx.isSender)
              ? (_openBlock(), _createElementBlock("td", _hoisted_6, "Aktionen"))
              : _createCommentVNode("", true),
            _hoisted_7
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(boxes.value, (box, i) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: `box_${box.id}`
            }, [
              (box.medication_box?.deleted != true)
                ? (_openBlock(), _createElementBlock("tr", {
                    key: 0,
                    class: _normalizeClass({
          'bg-green-4': box.medication_box?.status == 2,
          'bg-red-4': box.medication_box?.status == 3,
        })
                  }, [
                    _createElementVNode("td", _hoisted_8, [
                      _createVNode(ToolTip, {
                        position: "right",
                        width: "300px"
                      }, {
                        content: _withCtx(() => [
                          _createElementVNode("ul", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getBoxOrders(box.id), (order) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: order.id,
                                class: "flex items-center justify-start py-xs"
                              }, [
                                _createVNode(ProgressDot, {
                                  progress: statusOfMedicationOrder(order.medication_order),
                                  class: "mr-xs"
                                }, null, 8, ["progress"]),
                                _createElementVNode("div", null, [
                                  _createTextVNode(_toDisplayString(order.medication_order?.amount ?? "?") + "x " + _toDisplayString(order.medication_order?.name ?? "unb.") + " ", 1),
                                  _hoisted_9,
                                  _createElementVNode("i", null, _toDisplayString(_unref(patientString)(order.medication_order?.patient_id ?? -1)), 1)
                                ])
                              ]))
                            }), 128))
                          ]),
                          (getBoxOrders(box.id).length == 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                                _createVNode(ProgressDot, {
                                  progress: 4,
                                  class: "flex-0 mr-xs line-clamp-2"
                                }),
                                _hoisted_11
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(CircularProgress, {
                            progress: getProgressOfBoxId(box.id)
                          }, null, 8, ["progress"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createTextVNode(_toDisplayString(box.medication_box?.name ?? "unbenannte Kiste") + " ", 1),
                          _createElementVNode("span", _hoisted_14, " #" + _toDisplayString(box.id), 1),
                          _createElementVNode("span", _hoisted_15, _toDisplayString(`${box.medication_box?.address1 ?? ""} ${
                    box.medication_box?.zip ?? ""
                  } ${box.medication_box?.city ?? ""}`), 1)
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          (!_ctx.isSender)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createVNode(ReactiveSelect, {
                                  onChange: ($event: any) => (
                    updateBoxes(
                      box,
                      new Map([['status', parseInt($event?.id) ?? 0]])
                    )
                  ),
                                  "allow-empty": false,
                                  value: 
                    _unref(MedicationOrderBoxStatus).find(
                      (b) => b.id == box.medication_box?.status
                    )
                  ,
                                  class: "w-full",
                                  selectOptions: _unref(MedicationOrderBoxStatus),
                                  "option-label": "name",
                                  disabled: _ctx.isSender,
                                  "track-by": "id",
                                  loading: loadingMessages.value.has(box.id),
                                  placeholder: "Status wählen"
                                }, null, 8, ["onChange", "value", "selectOptions", "disabled", "loading"]),
                                (box.medication_box?.date || deliveryStatus.value)
                                  ? (_openBlock(), _createBlock(SmallTag, {
                                      key: 0,
                                      color: box.medication_box?.date ? 'lightblue' : 'blue',
                                      small: true,
                                      class: "w-auto self-end"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Lieferdatum: " + _toDisplayString(_unref(localeDateString)(
                      box.medication_box?.date ?? deliveryStatus.value?.desc ?? ""
                    )), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["color"]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createElementVNode("div", null, _toDisplayString(_unref(MedicationOrderBoxStatus).find(
                      (b) => b.id == box.medication_box?.status
                    )?.name), 1),
                                (box.medication_box?.date || deliveryStatus.value)
                                  ? (_openBlock(), _createBlock(SmallTag, {
                                      key: 0,
                                      color: box.medication_box?.date ? 'orange' : 'green',
                                      small: true,
                                      class: "w-multiselect self-end"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Lieferdatum: " + _toDisplayString(_unref(localeDateString)(
                      box.medication_box?.date ?? deliveryStatus.value?.desc ?? ""
                    )), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["color"]))
                                  : _createCommentVNode("", true)
                              ]))
                        ])
                      ])
                    ]),
                    (!_ctx.isSender)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createVNode(CoreIcon, {
                              onClick: ($event: any) => {
                editBox.value = i;
                showBoxModal.value = true;
              },
                              icon: "pen"
                            }, null, 8, ["onClick"]),
                            _createVNode(CoreIcon, {
                              onClick: ($event: any) => {
                printBoxes.value = [box];
                showPrintModal.value = true;
              },
                              icon: "pdf",
                              class: "ml-xs"
                            }, null, 8, ["onClick"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("td", _hoisted_20, [
                      _createVNode(CoreIcon, {
                        onClick: ($event: any) => (showHistoryOf.value = box),
                        icon: "changeLog"
                      }, null, 8, ["onClick"])
                    ])
                  ], 2))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ])),
    _createElementVNode("div", _hoisted_21, [
      (!_ctx.isSender)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createVNode(ReactiveSelect, {
              placeholder: "Lieferdatum",
              validation: "required",
              "track-by": "date",
              searchable: true,
              reset: "Unbekannt",
              "option-label": "label",
              selectOptions: _unref(upcomingDates)(),
              onChange: changeDate,
              value: deliveryStatus.value
            }, null, 8, ["selectOptions", "value"]),
            (
          (_ctx.conversation.senderCareProviderGroup.preferred_weekday?.length ??
            0) > 0
        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createTextVNode(" Vorschläge: "),
                  _createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedWeekdays(), (weekday) => {
                      return (_openBlock(), _createBlock(LabelButton, {
                        key: weekday?.id,
                        class: "!inline-block mx-xs",
                        label: weekday?.name,
                        onClick: ($event: any) => (changeDateAuto(weekday?.id ?? 0))
                      }, null, 8, ["label", "onClick"]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.isSender && boxes.value.length > 0)
      ? (_openBlock(), _createBlock(RoundedCard, {
          key: 2,
          color: "gray",
          class: "mt-s flex justify-between overflow-scroll"
        }, {
          default: _withCtx(() => [
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, [
              _createVNode(UButton, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => {
          showPrintModal.value = true;
          printBoxes.value = boxes.value;
        }),
                class: "ml-xs"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Etiketten ")
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(DialogCard, {
      "show-footer": false,
      title: "Kisten verwalten",
      "is-visible": showBoxModal.value,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (showBoxModal.value = false))
    }, {
      default: _withCtx(() => [
        _createVNode(OrderBoxManagement, {
          messages: props.messages,
          conversation: props.conversation,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (showBoxModal.value = false)),
          "open-box": editBox.value
        }, null, 8, ["messages", "conversation", "open-box"])
      ]),
      _: 1
    }, 8, ["is-visible"]),
    _createVNode(DialogCard, {
      "show-footer": false,
      title: "Etiketten Drucken",
      "is-visible": showPrintModal.value,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (showPrintModal.value = false))
    }, {
      default: _withCtx(() => [
        _createVNode(OrderPrintModal, {
          boxes: boxes.value,
          printBoxes: printBoxes.value,
          conversation: _ctx.conversation
        }, null, 8, ["boxes", "printBoxes", "conversation"])
      ]),
      _: 1
    }, 8, ["is-visible"]),
    _createVNode(OrderMessageHistory, {
      boxes: boxes.value,
      "of-message": showHistoryOf.value,
      onClose: _cache[5] || (_cache[5] = ($event: any) => (showHistoryOf.value = null)),
      type: "box"
    }, null, 8, ["boxes", "of-message"])
  ], 64))
}
}

})